import React from 'react'

function Faqpage() {
    return (
        <div>
            Faq page
        </div>
    )
}

export default Faqpage
